import { useAuth } from "@/shared/hooks";
import { EventTypes, useEvents } from "@/shared/hooks/useEvents";

import { StepId } from "./constants";

export const DataVerificationCompanyEventPrefix = "MORALPERSONFORM";

type DataVerificationCompanyEvents = {
    DataVerificationCompanyStarted: () => void;
    DataVerificationCompanyStopped: () => void;
    DataVerificationCompanyProgressed: (stepId: number) => void;
    DataVerificationCompanyFinalized: (success: boolean) => void;
};

export const useDataVerificationCompanyEvents = (): DataVerificationCompanyEvents => {
    const { user } = useAuth();
    const eventService = useEvents(DataVerificationCompanyEventPrefix);

    const DataVerificationCompanyStarted = () => {
        eventService.trackEvent(EventTypes.Start, { withLogin: !user.isScopedLogin() });
    };

    const DataVerificationCompanyStopped = () => {
        eventService.trackEvent(EventTypes.Stopped);
    };

    const DataVerificationCompanyFinalized = (success: boolean) => {
        eventService.trackEvent(EventTypes.Finalized, { success });
    };

    const DataVerificationCompanyProgressed = (stepId: number) => {
        eventService.trackEvent(EventTypes.Progressed, { step: StepId[stepId] });
    };

    return {
        DataVerificationCompanyStarted,
        DataVerificationCompanyStopped,
        DataVerificationCompanyFinalized,
        DataVerificationCompanyProgressed,
    };
};
